// Every product in this catalogue is single variant, so there is nothing to select
// on a PDP: the swatch rows are LINKS to sibling products and a swatch click is a
// full page navigation. The in-place variant-swap machinery this element used to
// carry (the `optionValueSelectionChange` subscription, the section refetch, the
// option-value re-render, the hidden-input mutation and the button/price/media
// resync that hung off them) is therefore gone -- the hidden `id` input is
// hard-bound to `product.selected_or_first_available_variant.id` in Liquid and no
// JS writes it. What remains is what was never about variant selection: the
// payment-button/XR bootstrap, the eager gallery init and the cart-driven
// quantity-rule refresh.
if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      cartUpdateUnsubscriber = undefined;

      constructor() {
        super();
      }

      get productId() {
        return this.getAttribute('data-product-id');
      }

      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }

      get productForm() {
        return this.querySelector('form[is="product-form"]');
      }

      get quantityInput() {
        return this.querySelector('quantity-input input');
      }

      connectedCallback() {
        window?.Shopify?.PaymentButton?.init();
        window?.ProductModel?.loadShopifyXR();

        this.initQuantityHandlers();
        this.initMedia();
      }

      disconnectedCallback() {
        this.cartUpdateUnsubscriber?.();
        if (this.timer) clearInterval(this.timer);
      }

      // The eager gallery init is kept; `setActiveMedia` is NOT. That call only
      // ever reordered/scrolled the gallery to a newly selected variant's image,
      // and there is no selection to follow. `media-gallery` inits itself on
      // scroll-into-view too, so this only brings that forward -- and it upgrades
      // independently of this element, hence the poll.
      initMedia() {
        const productMedia = this.querySelector(`[id^="MediaGallery-${this.dataset.section}"]`);
        if (!productMedia) return;

        const initGallery = () => {
          if (typeof productMedia.init !== 'function') return false;
          productMedia.init();
          return true;
        };

        if (!initGallery()) {
          this.timer = setInterval(() => {
            if (initGallery()) {
              clearInterval(this.timer);
            }
          }, 100);
        }
      }

      initQuantityHandlers() {
        if (!this.quantityInput) return;

        this.setQuantityBoundries();
        if (!this.hasAttribute('data-original-section')) {
          this.cartUpdateUnsubscriber = FoxTheme.pubsub.subscribe(
            FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate,
            this.fetchQuantityRules.bind(this)
          );
        }
      }

      setQuantityBoundries() {
        FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.quantityBoundries, {
          data: {
            sectionId: this.sectionId,
            productId: this.productId,
          },
        });
      }

      fetchQuantityRules() {
        const currentVariantId = this.productForm?.productIdInput?.value;
        if (!currentVariantId) return;

        this.querySelector('.quantity__rules-cart')?.classList.add('btn--loading');

        fetch(`${this.getAttribute('data-url')}?variant=${currentVariantId}&section_id=${this.sectionId}`)
          .then((response) => response.text())
          .then((responseText) => {
            const parsedHTML = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.sectionId, this.productId, parsedHTML);
          })
          .catch((error) => {
            console.error(error);
          })
          .finally(() => {
            this.querySelector('.quantity__rules-cart')?.classList.remove('btn--loading');
          });
      }

      updateQuantityRules(sectionId, productId, parsedHTML) {
        if (!this.quantityInput) return;

        FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.quantityRules, {
          data: {
            sectionId,
            productId,
            parsedHTML,
          },
        });

        this.setQuantityBoundries();
      }
    }
  );
}
